export const customSelect = () => {

    const selectElements = document.querySelectorAll('.custom-select select');
    const titleElements = document.querySelectorAll('.custom-select__title');

    selectElements.forEach((selectElement, index) => {
        selectElement.addEventListener('change', function() {
            const selectedOption = selectElement.options[selectElement.selectedIndex];
            titleElements[index].textContent = selectedOption.textContent;
        });
    });


}